import { FunctionComponent, memo } from "react";
import { SpinnerUntil } from "@edgetier/components";
import { Page, PageContent, PageHeader } from "@edgetier/client-components";

import UsersTable from "./users-table";
import { IProps } from "./users.types";
import { useUsers } from "./users.utilities";
import UsersFilters from "./users-filters";
import "./users.scss";

/**
 * A page for displaying Watchtower users and inviting new users.
 */
const Users: FunctionComponent<IProps> = () => {
    const {
        data,
        isLoading,
        isFetching,
        fetchNextPage,
        fetchPreviousPage,
        hasNextPage,
        hasPreviousPage,
        search,
        resetPage,
    } = useUsers();
    return (
        <Page className="users">
            <PageHeader title="Users" />
            <PageContent>
                <div className="users__container">
                    <div className="users__table">
                        <UsersFilters
                            onSubmit={({ search: searchTerm }) => {
                                resetPage();
                                search(searchTerm);
                            }}
                        />
                        <SpinnerUntil data={data} isReady={!isLoading}>
                            {typeof data === "undefined" ? (
                                <>Error</>
                            ) : (
                                <UsersTable
                                    users={isFetching ? null : data.items}
                                    goToNextPage={fetchNextPage}
                                    goToPreviousPage={fetchPreviousPage}
                                    hasNext={hasNextPage}
                                    hasPrevious={hasPreviousPage}
                                />
                            )}
                        </SpinnerUntil>
                    </div>
                </div>
            </PageContent>
        </Page>
    );
};

export default memo(Users);
